import { observable } from 'mobx';
import {
  fetchContractList,
  fetchSignPrepareInfo,
  fetchSignResult,
  queryContractSignUrl,
  queryContractViewUrl,
} from '@/services/contract';
import { contractItemStatus } from '@/src/constant';

// 资质签约信息
const contract = observable({
  isWaitSign: false,
  contractList: [], // 资质签约列表
  pageNum: 0,
  signPrepareInfo: {},
  signResult: false,
  signUrl: '',
  viewUrl: '',
  // 更新签约信息
  updateContractInfo(payload) {
    const list = payload;
    let wait = false;
    if (list && list.length > 0) {
      for (let i = 0; i < list.length; i++) {
        const el = list[i];
        if (el.contractStatus === contractItemStatus.WAIT.code) {
          wait = true;
          break;
        }
      }
    }
    this.contractList = list;
    this.isWaitSign = wait;
  },
  // 获取电子合同签署链接
  async getContractSignUrl(payload) {
    const res = await queryContractSignUrl(payload);
    this.signUrl = res.signUrl;
    return res;
  },
  // 获取电子合同查看链接
  async getContractViewUrl(payload) {
    const res = await queryContractViewUrl(payload);
    this.viewUrl = res.downloadUrl;
    return res;
  },
  // 获取签约信息
  async getContractInfo(payload) {
    const res = await fetchContractList(payload);
    this.updateContractInfo(res);
    return res;
  },
  // 清空签约信息
  async clearContractInfo() {
    this.updateContractInfo([]);
  },
  // 签约准备信息
  async setSignPrepareInfo(payload) {
    const res = await fetchSignPrepareInfo(payload);
    this.signPrepareInfo = {
      certName: res.certName,
      certNo: res.certNo,
      item: res.item,
    };
    return res;
  },
  // 签约
  async setSignResult(payload) {
    await fetchSignResult(payload);
    this.signResult = true;
  },

})

export default contract;
